import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport.js";
import { _ as _sfc_main$3 } from "./VaCard.vue_vue_type_script_setup_true_lang.js";
import { _ as _sfc_main } from "./components/va-card-content/VaCardContent.vue_vue_type_script_setup_true_lang.js";
import { V as VaCardTitleBase } from "./components/va-card-title/VaCardTitle.js";
import { _ as _sfc_main$1 } from "./components/va-card-actions/VaCardActions.vue_vue_type_script_setup_true_lang.js";
import { _ as _sfc_main$2 } from "./components/va-card-block/VaCardBlock.vue_vue_type_script_setup_true_lang.js";
const VaCardContent = withConfigTransport(_sfc_main);
const VaCardTitle = withConfigTransport(VaCardTitleBase);
const VaCardActions = withConfigTransport(_sfc_main$1);
const VaCardBlock = withConfigTransport(_sfc_main$2);
const VaCard = withConfigTransport(_sfc_main$3);
export {
  VaCardContent as V,
  VaCardTitle as a,
  VaCardActions as b,
  VaCardBlock as c,
  VaCard as d
};
//# sourceMappingURL=index.js.map
